import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function postAgent11Api(params) {
  return authPost(`${baseUrl}/Agent11.ashx`, params);
}

export function postAgent12Api(params) {
  return authPost(`${baseUrl}/Agent12.ashx`, params);
}

export function postAgent21Api(params) {
  return authPost(`${baseUrl}/Agent21.ashx`, params);
}

export function postAgent14Api(params) {
  return authPost(`${baseUrl}/Agent14.ashx`, params);
}

export function manageCaption(params) {
  return authFormPost(
    `${window.location.protocol}//media.es51.com/api/caption.php`,
    params
  );
}
